import PageHero from "../components/PageHero";

export default function Terms() {
  return (
    <div data-testid="page-terms">
      <PageHero
        overline="Legal"
        title="Terms & Conditions"
        subtitle="Last updated: January 2026"
      />
      <section className="py-16 md:py-24 bg-cream">
        <div className="max-w-3xl mx-auto px-6 md:px-12 lg:px-16 font-body text-ink-700 text-lg leading-relaxed space-y-6 [&_h2]:font-headings [&_h2]:text-3xl [&_h2]:text-ink [&_h2]:mt-12 [&_h2]:mb-3 [&_h2]:tracking-tight [&_h2]:leading-tight">
          <p>
            These terms govern your use of the Unite Recruitment website and
            the engagement of our technology recruitment services. Please read them
            carefully. By using our website or engaging our services, you agree
            to these terms.
          </p>

          <h2>1. About us</h2>
          <p>
            Unite Recruitment is a technology recruitment agency based in Aotearoa, New
            Zealand. We connect candidates with employers across permanent,
            contract, and retained search engagements.
          </p>

          <h2>2. Use of website</h2>
          <p>
            The content on this website is provided for general information
            only. While we take care to keep information accurate, we make no
            warranties about completeness or fitness for a particular purpose.
            You agree not to misuse the website or interfere with its operation.
          </p>

          <h2>3. Candidate services</h2>
          <p>
            Candidates do not pay any fee to use our services. By submitting
            your CV or registering with us, you consent to us discussing your
            profile with prospective employers where we believe a genuine fit
            exists. We will always seek your permission before formally
            submitting your details to a specific role.
          </p>

          <h2>4. Employer engagements</h2>
          <p>
            Employer engagements are governed by a separate written agreement
            signed prior to commencement of any search. Standard terms include
            our placement fee, replacement guarantee, and confidentiality
            obligations.
          </p>

          <h2>5. Intellectual property</h2>
          <p>
            All content on this website — including text, design, logos, and
            graphics — is owned by Unite Recruitment or licensed to us. You may
            not copy, reproduce, or distribute it without our prior written
            consent.
          </p>

          <h2>6. Limitation of liability</h2>
          <p>
            To the extent permitted by law, Unite Recruitment is not liable for
            any indirect or consequential loss arising from your use of this
            website or our services. Nothing in these terms limits any rights
            you may have under the Consumer Guarantees Act 1993 or other
            non-excludable statutory rights.
          </p>

          <h2>7. Governing law</h2>
          <p>
            These terms are governed by the laws of New Zealand. Any dispute
            will be subject to the exclusive jurisdiction of the New Zealand
            courts.
          </p>

          <h2>8. Changes</h2>
          <p>
            We may update these terms from time to time. The most current
            version will always be posted on this page.
          </p>

          <h2>9. Contact</h2>
          <p>
            Questions about these terms? Email us at{" "}
            <a
              href="mailto:Bronwyn@uniterecruitment.co.nz"
              className="underline text-ink"
            >
              Bronwyn@uniterecruitment.co.nz
            </a>{" "}
            or call <a href="tel:+64274382028" className="underline text-ink">0274 382 028</a>.
          </p>
        </div>
      </section>
    </div>
  );
}
